import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { fuseAnimations } from '@fuse/animations';
import { CommonModule } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';
import { ConfigService } from '../../../services/config.service';
import { FileService } from '../../../services/file.service';
import tinycolor from 'tinycolor2';
import { TranslocoPipe, TranslocoService } from '@ngneat/transloco';
import { DrakeSharedService } from '../../../services/drake-shared.service';


@Component({
    selector: 'app-login-step2',
    templateUrl: './login-step2.component.html',
    styleUrls: ['./login-step2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        QRCodeModule,
        TranslocoPipe
    ],
    providers: [TranslocoPipe]
})
export class LoginStep2Component implements OnInit {
    otpForm: FormGroup;
    qrCodeUri: string;
    @Input() userSid: string;
    @Input() factorSid: string;
    username: string;
    hasFactorSid: string;
    backgroundColor: string;
    logoUrl: string;
    logoId: string;
    textColor: string;
    introductionHtml: string;
    customColor: string;


    constructor(
        private fb: FormBuilder,
        private _activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private fileService: FileService,
        private configService: ConfigService,
        private translocoService: TranslocoService,
        private drakeSharedService: DrakeSharedService,
        private translocoPipe: TranslocoPipe


    ) { }

    ngOnInit(): void {

        this.otpForm = this.fb.group({
            otp: ['', Validators.required],
        });

        //this.userSid = sessionStorage.getItem('UserSid');
        //this.factorSid = sessionStorage.getItem('FactorSid');

        //this.username = sessionStorage.getItem('Username');
        this.username = this._activatedRoute.snapshot.queryParamMap.get('username');
        this.hasFactorSid = JSON.parse(sessionStorage.getItem("hasFactorSid"));//this._activatedRoute.snapshot.queryParamMap.get('hasFactorSid');
        this.userSid = sessionStorage.getItem("userSid");
        this.factorSid = sessionStorage.getItem("factorSid");



        console.log("UserSid: ", this.userSid, " Username: ", this.username);

        this.loadBranding('DEFAULT');
        if(!this.hasFactorSid)
            this.registerOtp(this.userSid);

    }

    loadBranding(id: string): void {
        console.log("Loading branding with ID:", id);
        this.configService.getBranding(id).subscribe({
            next: (config: any) => {
                console.log("Received branding config:", config);
                if (config) {
                    this.backgroundColor = config.brdColor1 || this.backgroundColor;
                    this.logoId = config.brdLogo1 || this.logoUrl;
                    this.textColor = config.brdColor2 || this.textColor;
                    this.introductionHtml = config.brdSigninHtml || this.introductionHtml;
                    this.customColor = config.brdColor3 || this.customColor;

                    this.setCustomColor(this.backgroundColor, 'background');
                    this.setCustomColor(this.textColor, 'text');
                    this.setCustomColor(this.customColor, 'custom');

                    if (this.logoId) {
                        this.fileService.readFileAsBase64String(this.logoId).subscribe((result: any) => {
                            console.log("logo ", result);
                            this.logoUrl = result.dataUrl;
                            config.brdLogo1 = result.dataUrl
                            localStorage.setItem('branding', JSON.stringify(config));
                        });
                    } else {
                        localStorage.setItem('branding', JSON.stringify(config));
                    }

                    console.log("Branding saved in localStorage:", localStorage.getItem('branding'));
                } else {
                    console.warn("Branding config is undefined or null");
                }
            },
            error: (error: any) => {
                console.error('Error loading branding:', error);
            },
            complete: () => {
                console.log('Branding loading completed');

                var lang = this.translocoService.getActiveLang();
                if (localStorage.lang) {
                    lang = localStorage.lang;
                }
                this.translocoService.setActiveLang(lang);
                this.translocoService.load(lang).subscribe(a => {
                    this.translocoService.selectTranslation(lang);
                });
            }
        });
    }

    setCustomColor(color: string, name: string): void {
        document.documentElement.style.setProperty(`--${name}-color`, color);
        document.documentElement.style.setProperty(`--${name}-light`, this.lighten(color, 20));
        document.documentElement.style.setProperty(`--${name}-dark`, this.darken(color, 20));
        document.documentElement.style.setProperty(`--${name}-lighter`, this.lighten(color, 40));
        document.documentElement.style.setProperty(`--${name}-darker`, this.darken(color, 40));
    }

    lighten(color: string, percent: number): string {
        return tinycolor(color).lighten(percent).toString();
    }

    darken(color: string, percent: number): string {
        return tinycolor(color).darken(percent).toString();
    }

    verifyOtp(): void {
        if (this.otpForm.invalid) {
            return;
        }

        const verifyOtpRequest = {
            OtpMode: 'TWILIO',
            UserSid: this.userSid,
            FactorSid: this.factorSid,
            Otp: this.otpForm.value.otp,
            Username: this.username,
            Login: true
        };

        console.log(verifyOtpRequest);

        this.authService.verifyTotp(verifyOtpRequest).subscribe(
            response => {
                if (response.status == "OK") {
                    var notification = this.translocoPipe.transform("notification.success.loginStep2.otp");
                    this.drakeSharedService.showTemporaryNotification(notification, 'success');
                    this.authService.otpTrue = true;
                    localStorage.setItem('otpTrue', 'true');
                    sessionStorage.setItem('hasFactorSid', 'true');
                    const redirectURL = this._activatedRoute.snapshot.queryParamMap.get('redirectURL') || '/signed-in-redirect';
                    this.router.navigateByUrl(redirectURL);


                } else {
                    var notification = this.translocoPipe.transform("notification.error.loginStep2.otp");
                    this.drakeSharedService.showTemporaryNotification(notification, 'error');
                    this.authService.otpTrue = false;
                    localStorage.setItem('otpTrue', 'false');
                    sessionStorage.setItem('hasFactorSid', 'false');
                    console.error('OTP verification failed:', response.message);
                }
            },
            error => {
                var notification = this.translocoPipe.transform("notification.error.loginStep2.otp");
                this.drakeSharedService.showTemporaryNotification(notification, 'error');
                console.error('OTP verification failed:', error.error.message || error.message);
            }
        );
    }

    registerOtp(userSid: string): void {
        const registerOtpRequest = {
            OtpMode: 'TWILIO',
            UserSid: this.userSid,
            Username: this.username
        };

        this.authService.registerTotp(registerOtpRequest).subscribe(response => {
            this.qrCodeUri = response.uri;
            this.factorSid = response.factorSid;

            const factorSidRegisterRequest = {
                UserSid: this.userSid,
                FactorSid: this.factorSid,
                Scope: "USERS"
            };

            this.authService.factorSidRegister(factorSidRegisterRequest).subscribe(registerResponse => {
                if (registerResponse.status === 'OK') {
                    console.log('FactorSid successfully registered.');
                } else {
                    console.error('Error registering FactorSid:', registerResponse.message);
                }
            }, error => {
                console.error('HTTP error registering FactorSid:', error);
            });
        }, error => {
            console.error('HTTP error registering OTP:', error);
        });
    }

}
